import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { COLLAR_GROUPS } from '../collar-group.mock';
import { COLLARS } from '../collar.mock';

@Injectable()
export class CollarEntityServiceMock {
  entities$ = of(COLLARS);

  getAll() {
    return of(COLLARS);
  }

  getFilteredItems() {
    return of(COLLARS);
  }
}

@Injectable()
export class CollarGroupEntityServiceMock {
  entities$ = of(COLLAR_GROUPS);

  getAll() {
    return of(COLLAR_GROUPS);
  }
}
